/**
 * Browser-only image conversion helpers. Kept separate from mediaTypeDetection
 * so Cloudflare Functions (no DOM lib) can import ext sets without pulling in
 * OffscreenCanvas / createImageBitmap types.
 */

export async function convertBlobToWebP(blob: Blob, quality = 0.9): Promise<Blob> {
  const bitmap = await createImageBitmap(blob);
  const canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
  const ctx = canvas.getContext('2d')!;
  ctx.drawImage(bitmap, 0, 0);
  const webpBlob = await canvas.convertToBlob({ type: 'image/webp', quality });
  bitmap.close();
  return webpBlob;
}
